export class LoaderTariff {
  min_price: number = 0;
  min_hours: number = 1;
  additional_hour_price: number = 0;
  on_the_way_hour_price: number = 0;
}
